import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'
import { DarkTheme } from './Themes';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'
import Shreenath from '../assets/Images/Shreenath-Dark.png'

const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;

`
const float = keyframes`
0% { transform: translateY(-10px) }
50% { transform: translateY(15px) translateX(15px) }
100% { transform: translateY(-10px) }

`
const Spaceman = styled.div`
position: absolute;
top: 21%;
right: 5%;
width: 27vw;
animation: ${float} 4s ease infinite;
img{
    width: 100%;
    height: auto;
}

@media (max-width: 768px) {
    top:2.1rem;
    right:1.9rem;
    width: 41vw;
    z-index: 3;
  }
`
const Main = styled.div`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 50vw;
  height: 60vh;
  z-index: 3;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.6rem + 1vw);
 backdrop-filter: blur(4px);
  
  position: absolute;
  left: calc(5rem + 5vw);
  top: 10rem;
  font-family: 'Ubuntu Mono', monospace;
  font-style: italic;
  
  @media (max-width: 768px) {
    left: 4.1rem;
    padding: 1.6rem;
    width: 59vw;
  height: 55vh;
  top:12rem
    
  }
`




const AboutPage = () => {
  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>

        <LogoComponent theme='dark' />
        <SocialIcons theme='dark' />
        <PowerButton />
        <ParticleComponent theme='dark' />

        <Spaceman>
          <img src={Shreenath} alt="Shreenath-Profile" />
        </Spaceman>
        <Main>
          Hi, I'm Shreenath G L, a passionate Full Stack Developer skilled in building modern web applications. I specialize in crafting dynamic interfaces using HTML, CSS, JavaScript, TypeScript, React, Next.js, Redux, Tailwind, and ShadCN.
          <br /><br />
          On the backend, I develop robust solutions with Node.js, Express, MongoDB, and Docker. I thrive on solving complex problems while continuously evolving my skills.
          <br /><br />
          Let's connect and create innovative, user-centric digital experiences together!
        </Main>


        <BigTitle text="ABOUT" top="10%" left="5%" />


      </Box>

    </ThemeProvider>

  )
}

export default AboutPage
